import { C28RichTextWithCTAProps } from './C28RichTextWithCTA.types';
import { getDroplink } from 'src/shared/param-utils';
import { RichTextWithCtaProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateRichTextWithCtaModel(props?: C28RichTextWithCTAProps): RichTextWithCtaProps {
  const { fields, params } = props || {};

  type t = RichTextWithCtaProps;

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    firstCta: renderLink(fields?.FirstCta),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    secondCta: renderLink(fields?.SecondCta),
    secondCtaStyle: getDroplink<t['secondCtaStyle']>(params?.SecondCtaStyle, 'default'),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
  };
}
